import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import EpisodeCard from '@/components/feature/EpisodeCard';
import { getDramaById, getLatestEpisodes } from '@/lib/content';

export default function LatestUpdates() {
  const latest = getLatestEpisodes(6);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionTitle
          eyebrow="更新同步"
          title="最新剧集更新"
          description="按更新时间倒序排列，第一时间了解《迷人的保姆》及相关剧集的最新章节动态。"
          linkTo="/category"
          linkLabel="查看全部剧集"
        />
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          {latest.map((episode) => {
            const drama = getDramaById(episode.dramaId);
            return (
              <EpisodeCard key={episode.id} episode={episode} dramaTitle={drama?.title} />
            );
          })}
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            浏览完整剧集列表
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}